import styles from "../HealthChat.module.css";

/* ─── SVG icons ─────────────────────────────────────────────────────────── */
const NewPatientIcon = ({ size = 52 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--primary-color)"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
    <line x1="19" y1="8" x2="19" y2="14" />
    <line x1="16" y1="11" x2="22" y2="11" />
  </svg>
);

const ExistingPatientIcon = ({ size = 52 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="var(--primary-color)"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
    <polyline points="16 11 18 13 22 9" />
  </svg>
);

/* ─── Copy ───────────────────────────────────────────────────────────────── */
const COPY = {
  en: {
    title: "Patient Information",
    subtitle: "Are you a new patient or an existing patient?",
    backBtn: "Back",
    options: [
      {
        id: "new",
        label: "New Patient",
        desc: "First time booking with us",
        Icon: NewPatientIcon,
      },
      {
        id: "existing",
        label: "Existing Patient",
        desc: "I've booked an appointment before",
        Icon: ExistingPatientIcon,
      },
    ],
  },
  hi: {
    title: "रोगी जानकारी",
    subtitle: "क्या आप नए रोगी हैं या पहले से हमारे रोगी हैं?",
    backBtn: "वापस",
    options: [
      {
        id: "new",
        label: "नया रोगी",
        desc: "पहली बार बुकिंग",
        Icon: NewPatientIcon,
      },
      {
        id: "existing",
        label: "मौजूदा रोगी",
        desc: "पहले अपॉइंटमेंट ले चुके हैं",
        Icon: ExistingPatientIcon,
      },
    ],
  },
  te: {
    title: "రోగి సమాచారం",
    subtitle: "మీరు కొత్త రోగి లేదా ఇప్పటికే ఉన్న రోగి?",
    backBtn: "వెనుకకు",
    options: [
      {
        id: "new",
        label: "కొత్త రోగి",
        desc: "మొదటిసారి బుకింగ్",
        Icon: NewPatientIcon,
      },
      {
        id: "existing",
        label: "ఇప్పటికే ఉన్న రోగి",
        desc: "ముందే అపాయింట్మెంట్ బుక్ చేసారు",
        Icon: ExistingPatientIcon,
      },
    ],
  },
};

/* ─── Component ─────────────────────────────────────────────────────────── */
export default function PatientInfoScreen({ lang = "en", onSelect, onBack }) {
  const c = COPY[lang] || COPY.en;

  return (
    <div className={styles.patientInfoScreen}>
      <button className={styles.selectDoctorBack} onClick={onBack}>
        ← Back
      </button>
      <div className={styles.patientInfoTitle}>{c.title}</div>
      <div className={styles.patientInfoSub}>{c.subtitle}</div>

      <div className={styles.patientInfoGrid}>
        {c.options.map(({ id, label, desc, Icon }) => (
          <div
            key={id}
            className={styles.patientInfoCard}
            onClick={() => onSelect(id)}
          >
            <div className={styles.patientInfoIcon}>
              <Icon size={50} />
            </div>
            <div className={styles.patientInfoLabel}>{label}</div>
            <div className={styles.patientInfoDesc}>{desc}</div>
          </div>
        ))}
      </div>

      {/* <button className={styles.backOutlineBtn} onClick={onBack}>
        {c.backBtn}
      </button> */}
    </div>
  );
}
